module.exports = {"id":"226797","name":"Ignacio Malcorra","rating":"72","photo":"./data/images/photos/1/226797.png","club":{"name":"Tijuana","logo":"./data/images/clubs/Tijuana.png"},"positions":["MG","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IgnacioMalcorra0.json
// module id = 1780
// module chunks = 0